module.exports = __webpack_public_path__ + "img/libaotext.47948eae.png";